import type { SelectableContentOption } from '@shared/data/selectableContent';

type Props = {
  options: SelectableContentOption[];
  isSelected: (option: SelectableContentOption) => boolean;
  onToggle: (option: SelectableContentOption, enabled: boolean) => void;
};

/**
 * Controlled expansion/module checkboxes — one event flow, no double-toggle.
 * Immediate parent state update; parent persists.
 */
export function ExpansionToggleList({ options, isSelected, onToggle }: Props) {
  if (options.length === 0) {
    return (
      <p className="meta">
        Brak zarejestrowanych dodatków / modułów dla tej gry.
      </p>
    );
  }

  return (
    <div className="expansion-list" role="group" aria-label="Dodatki i moduły">
      {options.map((option) => {
        const checked = isSelected(option);
        const disabled = Boolean(option.alwaysOn);
        return (
          <label
            key={option.id}
            className={`expansion-row${disabled ? ' locked' : ''}`}
            data-testid={`expansion-${option.id}`}
          >
            <input
              type="checkbox"
              checked={checked}
              disabled={disabled}
              data-testid={`expansion-checkbox-${option.id}`}
              onChange={(event) => {
                event.stopPropagation();
                if (disabled) return;
                onToggle(option, event.target.checked);
              }}
              onClick={(event) => event.stopPropagation()}
            />
            <span className="expansion-copy">
              <strong>{option.title}</strong>
              {option.description ? <span>{option.description}</span> : null}
              {disabled ? <em>Zawsze aktywne</em> : null}
            </span>
          </label>
        );
      })}
    </div>
  );
}
